<template>
<div class="chapter">
<div class="inner_page">
<div class="otherbooks" id="ded">
<div class="block">
<p class="nonindent">We dedicate this book to our readers. May it become a pathfinder’s companion on the journey to the personal rediscovery of an intimate, separate self in wholesome relationship.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062043740_epub_ded_r1.vue?b060c524